/* tslint:disable */
/* eslint-disable */
/**
 * home-health-api
 * home-health-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { KinnserLookups } from './KinnserLookups';
import {
    KinnserLookupsFromJSON,
    KinnserLookupsFromJSONTyped,
    KinnserLookupsToJSON,
    KinnserLookupsToJSONTyped,
} from './KinnserLookups';

/**
 * 
 * @export
 * @interface GetKinnserLookups200Response
 */
export interface GetKinnserLookups200Response {
    /**
     * 
     */
    data?: KinnserLookups;
}

/**
 * Check if a given object implements the GetKinnserLookups200Response interface.
 */
export function instanceOfGetKinnserLookups200Response(value: object): value is GetKinnserLookups200Response {
    return true;
}

export function GetKinnserLookups200ResponseFromJSON(json: any): GetKinnserLookups200Response {
    return GetKinnserLookups200ResponseFromJSONTyped(json, false);
}

export function GetKinnserLookups200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetKinnserLookups200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'data': json['data'] == null ? undefined : KinnserLookupsFromJSON(json['data']),
    };
}

export function GetKinnserLookups200ResponseToJSON(json: any): GetKinnserLookups200Response {
    return GetKinnserLookups200ResponseToJSONTyped(json, false);
}

export function GetKinnserLookups200ResponseToJSONTyped(value?: GetKinnserLookups200Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': KinnserLookupsToJSON(value['data']),
    };
}

